import React from 'react'
import styles from './TopBar.module.css'
import { useNavigate } from 'react-router-dom'

const TopBar = () => {
    const navigate = useNavigate()
    return (
        <div className={styles.TopBarDiv} onClick={() => navigate('/deseyne-medtech-breakthrough-award-2026')} style={{ cursor: 'pointer' }}>
            <p>2026 MEDTECH BREAKTHROUGH AWARD - BEST NEW TECHNOLOGY SOLUTION - OPHTHALMOLOGY</p>
        </div>
    )
}

export default TopBar